import React from 'react';
import { Line } from 'react-chartjs-2';
const LineChart = ({ options, chartData, height }: any) => {
  return <Line options={options} data={chartData} height={120} />;
};

export default LineChart;
